export const getAlertIcon = (alertType: number) => {
  switch (alertType) {
    case 3: // Unit entered Geofence
    case 4: // Unit leaves Geofence
    case 8: // Unit not sent data for a period of time
    case 26: // Unit out of route
    case 30: // Light sensor activated
    case 41: // Light sensor tampered
      return 'icon-small_solid_alert';
    default:
      return 'icon-small_solid_package-2';
  }
};
